import { useTranslation } from "react-i18next";

import ProceedButton from "../../../../components/buttons/proceedButton/ProceedButton";
import useNavigateTo from "../../../../hooks/useNavigateTo";
import OrderSummary from "../../components/summary/OrderSummary";
import "./ConfirmationScreen.scss";

interface ConfirmationScreenProps {
  createdDeliveryId?: string;
}

const ConfirmationScreen = (props: ConfirmationScreenProps) => {
  const { t } = useTranslation();
  const { navigateToDeliveryDetails } = useNavigateTo();
  const { createdDeliveryId } = props;

  return (
    <>
      <div className="page-content-divider mt-0 mb-0" />
      <OrderSummary isConfirmation={true} />
      <div className="page-content-button-container mt-10">
        <div className="page-content-button-container-button-center">
          <ProceedButton
            onProceed={() => navigateToDeliveryDetails(createdDeliveryId || "")}
            value={t("toDetails")}
            variant="outlined"
          />
        </div>
      </div>
    </>
  );
};

export default ConfirmationScreen;
